<template>
  <div>
    <slot name="button" :file-upload-button-click="onButtonClick" />
    <Modal v-if="visible" ref="modal" @close="visible = false">
      <div class="modal max-w-md mx-auto" @click.stop>
        <div class="modal__header">
          <h6 class="heading">
            {{ title }}
          </h6>
        </div>
        <div class="modal__body">
          <div class="flex flex-col">
            <slot :file-list="fileList">
              <FileUploadItem v-for="file in fileList" :key="file.id" :file="file" />
            </slot>
          </div>
        </div>

        <div class="modal__body">
          <form @submit.prevent="onUpload" class="space-x-2">
            <label v-if="!storing" for="file-upload" class="btn btn-brand ml-auto">
              {{ $t('select') | capitalize }}
            </label>
            <input
              id="file-upload"
              type="file"
              ref="upload"
              :disabled="storing"
              :multiple="multiple"
              class="hidden"
              @change="onChangeFile($event.target.files)"
            />
            <button
              type="submit"
              v-if="Object.keys(files).length"
              :disabled="storing"
              class="btn btn-brand"
            >
              {{ $t('upload') | capitalize }}
            </button>
            <Loader v-if="storing" />
          </form>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { omit } from 'lodash-es';
import Modal from '@/components/Ui/Modal.vue';
import FileUploadItem from '@/components/Ui/fileUpload/FileUploadItem.vue';

export default {
  name: 'FileUpload',
  components: {
    Modal,
    FileUploadItem,
  },
  props: {
    multiple: Boolean,
    title: {
      type: String,
      default: 'File Upload',
    },
  },
  data: () => ({
    visible: false,
    files: {},
  }),
  computed: {
    fileList() {
      return Object.keys(this.files).map((key) => this.files[key]);
    },
    storing() {
      return Object.keys(this.files).some((key) => this.files[key].storing);
    },
  },
  methods: {
    onButtonClick() {
      this.visible = true;
    },
    onChangeFile(filelist) {
      const { multiple } = this;
      Array.from(filelist).forEach((file) => {
        const newFile = this.prepareFile(file);
        if (!newFile) return;
        this.files = {
          [newFile.id]: newFile,
          ...(multiple ? this.files : {}),
        };
      });

      this.$refs.upload.value = '';
    },
    onDeleteFile(fileId) {
      this.files = { ...omit(this.files, [fileId]) };
      const URL = window.URL || window.webkitURL;
      if (URL && URL.revokeObjectURL) {
        URL.revokeObjectURL(this.files.blob);
      }
    },
    onUpload() {
      const { files } = this;

      Object.keys(files).forEach((key) => {
        const config = {
          onUploadProgress(progressEvent) {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            files[key].progress = progress;
          },
        };

        const data = new FormData();
        files[key].storing = true;
        data.append('file', files[key].file);

        this.$emit('file-upload', {
          data,
          config,
          success: () => {
            this.files[key].storing = false;
            this.files[key].success = true;
            this.$emit('file-upload-success');
            if (!this.storing) {
              this.$refs.modal.closeModal();
            }
          },
          error: () => {
            this.files[key].storing = false;
            this.files[key].error = true;
            this.$emit('file-upload-failed');
          },
        });
      });
    },
    prepareFile(file) {
      if (file.type.substr(0, 6) !== 'image/' && file.type !== 'application/pdf') {
        return false;
      }

      let blob = '';
      if (file.type.substr(0, 6) === 'image/') {
        // Create a blob field
        const URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          blob = URL.createObjectURL(file);
        }
      }

      const id = Math.random().toString(36).substr(2);

      return {
        id,
        file,
        blob,
        thumb: blob || '',
        category: null,
        url: null,
        source: null,
        progress: 0,
        storing: false,
        success: false,
        error: false,
      };
    },
  },
};
</script>
